import { useAppDispatch, useAppSelector, useIsMobile } from '../../../../../base/hooks';
import { __t } from '../../../../../base/utils/t';
import { responsesActions } from '../../redux/slices/responsesSlice';
import { StatusSelect } from './DesktopSelects/StatusSelect';
import { VacancyItemAll, VacancySelect } from './DesktopSelects/VacancySelect';
import { HireStatus } from '../../enums';
import { DateRangeSelect } from './DesktopSelects/DateRangeSelect';
import { StatusSelectMobile } from './MobileSelects/StatusSelectMobile';
import { SearchInput } from './SearchInput';

import './styles.scss';
import { DateRangeSelectMobile } from './MobileSelects/DateRangeSelectMobile';
import { VacancySelectMobile } from './MobileSelects/VacancySelectMobile';

interface Props {
    className?: string;
}

export const FilterSearch = ({ className = '' }: Props) => {
    const isMobile = useIsMobile();
    const dispatch = useAppDispatch();
    const isDefaultFilterSelected = useAppSelector(
        (state) =>
            state.employerResponses.filters.hireStatus === HireStatus.All &&
            state.employerResponses.filters.vacancyId === VacancyItemAll.id &&
            !state.employerResponses.filters.dateFrom &&
            !state.employerResponses.filters.dateTo,
    );

    const clearFiltersHandler = () => dispatch(responsesActions.clearFilters());

    return (
        <div className={`responses-filter-search ${className}`}>
            <div className='responses-filter-search__filters responses-filters'>
                <p className='responses-filters__title'>{__t('Фільтр')}:</p>
                <div className='responses-filters__filters-wrap'>
                    {isMobile ? (
                        <>
                            <VacancySelectMobile className='responses-filters__filter' />
                            <DateRangeSelectMobile className='responses-filters__filter' />
                            <StatusSelectMobile className='responses-filters__filter' />
                        </>
                    ) : (
                        <>
                            <VacancySelect className='responses-filters__filter' />
                            <DateRangeSelect className='responses-filters__filter' />
                            <StatusSelect className='responses-filters__filter' />
                        </>
                    )}
                    {!isDefaultFilterSelected && (
                        <button className='responses-filters__clear-filters-button' onClick={clearFiltersHandler}>
                            {__t('Очистити')}
                        </button>
                    )}
                </div>
            </div>
            <SearchInput />
        </div>
    );
};
